// extracted by mini-css-extract-plugin
export var errorIcon = "_mu-1";
export var nameLogo = "_mu-0";